<div
  [class]="'pr-form-list-header ' + (headerClass ? headerClass + ' ' : '')"
  (click)="open()"
  (swipeleft)="open()"
  [ngClass]="{ 'is-invalid': derrors && form?.form?.status === 'INVALID' }"
>
  <div class="pr-form-list-title">
    <ng-content select="[title]"></ng-content>
  </div>
  <i class="fa fa-chevron-right" aria-hidden="true"></i>
</div>
<div #item class="pr-form-list-item" (swiperight)="cancel()">
  <div class="pr-form-title">
    <div class="pr-form-title-primary" (click)="cancel()">
      @if (showReturnChevron) {
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      }
      Retour
    </div>
    <div class="pr-form-title-secondary"></div>
  </div>
  <div [class]="'pr-form-content ' + clazz">
    <ng-content select="[item]"></ng-content>
    <pr-button-confirm
      [display]="buttonStyle === 'icon' ? 'danger' : ''"
      displayConfirm="danger"
      [icon]="buttonStyle === 'icon' ? 'delete_outline' : ''"
      modalIcon="delete_outline"
      [leftIcon]="buttonStyle === 'label' ? 'sp-trash' : ''"
      [iconViewBoxWidth]="buttonIconVbWidth"
      [iconViewBoxHeight]="buttonIconVbHeight"
      [label]="buttonStyle === 'label' ? 'Supprimer ' + itemName : ''"
      (onConfirm)="delete()"
      comment="Toute suppression est definitive, les données seront perdues."
      labelConfirm="Supprimer"
      labelCancel="Annuler"
      [clazz]="buttonClass"
    >
      Êtes-vous sûr(e) de vouloir supprimer
      <em class="text-red"> {{ itemName }} </em> ?
    </pr-button-confirm>
  </div>
  <div class="pr-form-submit flex-row">
    <pr-button
      clazz="btn-cancel neutral"
      size="lg"
      label="Annuler"
      (onClick)="cancel()"
    ></pr-button>
    <pr-button
      size="lg"
      label="Sauvegarder"
      display="neutral"
      (onClick)="validate()"
    ></pr-button>
  </div>
</div>
